var createArray = function (length) {
    if (length === void 0) { length = 0; }
    return Array.from({ length: length }, function (x, i) { return i; });
};
export { createArray };
